module.exports = __webpack_public_path__ + "img/19.15c0bffa.jpg";